import * as React from 'react';
import { formatoDecimal } from '../../../../utilities/formatoNumeros';

export default class LiquidacionNewOrdenes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ordenes: props.ordenes,
            seleccionarTodo: false
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.ordenes !== this.props.ordenes) {
            this.setState({ ordenes: this.props.ordenes })
        }
    }

    handleChangeCheckbox = (id) => {
        this.setState((prevState) => {
            const ordenes = prevState.ordenes.map((orden) => {
                if (orden.idOrden === id) {
                return {
                    ...orden,
                    checked: !orden.checked
                };
                }
                return orden;
            });
            return { ordenes };
        });
    };
    
    handleSelectAllCheckbox(seleccionarTodo) {
        this.setState((prevState) => {
            const ordenes = prevState.ordenes.map((orden) => ({
                ...orden,
                checked: seleccionarTodo
            }));
            return { ordenes };
        });

        this.setState({ seleccionarTodo: seleccionarTodo });
    };
    

    render = () => {

        return (

            this.state.ordenes.length === 0 ?

            <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                NO SE ENCONTRARON ORDENES PARA ESTE SELLER
            </h5>

            :

            <div className="row justify-content-between align-items-center p-10">

                <div className="col-auto my-4">
                    <input
                        type="checkbox" 
                        className="big-checkbox"
                        checked={this.state.seleccionarTodo}
                        onChange={() => this.handleSelectAllCheckbox(!this.state.seleccionarTodo)}
                    />
                    <h6 className="d-inline-flex mx-2">Seleccionar todo</h6>
                </div>

                <h4 className="col-auto card-title">Ordenes aptas para liquidar</h4>

                <div className="list-group-item col-12 animated fadeIn">
                    <div className="table-responsive card">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col"><small>#</small></th>
                                    <th scope="col"><small>Numero</small></th>
                                    <th scope="col"><small>Fecha</small></th>
                                    <th scope="col"><small>Tipo</small></th>
                                    <th scope="col"><small>Importe</small></th>
                                    <th scope="col"><small>Comisión Neta</small></th>
                                    <th scope="col"><small>Comisión Total</small></th>
                                    <th scope="col"><small>Importe Total</small></th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.ordenes.map((orden, i) => {
                                    return (
                                        <tr key={i} className="hover-background-color">
                                            <td>
                                                <input 
                                                    type="checkbox" 
                                                    className="big-checkbox ml-2"
                                                    hidden={orden.importeOrden === 0}
                                                    checked={orden.checked || false}
                                                    onChange={() => this.handleChangeCheckbox(orden.idOrden)}
                                                />
                                            </td>
                                            <td>
                                                <small>{orden.idOrden}</small>
                                            </td>
                                            <td>
                                                <small>{orden.fechaOrdenMostrar}</small>
                                            </td>
                                            <td>
                                                <small>{orden.tipoPublicacion}</small>
                                            </td>
                                            <td>
                                                <small>${formatoDecimal(orden.importeOrden)}</small>
                                            </td>
                                            <td>
                                                <small>${formatoDecimal(orden.importeComisionNeta)}</small>
                                            </td>
                                            <td>
                                                <small>${formatoDecimal(orden.importeComisionTotal)}</small>
                                            </td>
                                            <td>
                                                <small>${formatoDecimal(orden.totalOrden)}</small>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}